import { observable, action } from 'mobx';
import { ICardDesign } from '../../../interfaces/ICardDesign';
import { IContentOrganizerCreate } from '../../../interfaces/IContentOrganizerCreate';
import ContentOrganizerService from '../../../services/ContentOrganizerService';

export class ContentOrganizerPortalStore {

  @observable public environment: "Development" | "Test" | "Production";
  @observable public tenant: string;
  @observable public token: string;
  @observable public listInstances: IContentOrganizerCreate[];
  @observable public searchQuery: string;
  @observable public searchPlaceholder: string;
  @observable public title: string;
  @observable public numberOfCardsPerRow: number;
  @observable public design?: ICardDesign;

  @action public updateSearchQuery(searchQuery: string): void {
    if (searchQuery !== this.searchQuery) {
      this.searchQuery = searchQuery;
      ContentOrganizerService.getContentOrganizerInstancesList(
        this.environment,
        this.token,
        this.tenant,
        "true",
        this.searchQuery).then(instances => {
          this.listInstances = instances;
        });
    }
  }
}